import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { BillingParty } from "../../../graphql/billing_party.datatypes";

interface MyBillingPartyData {
    billingParty: BillingParty;
}

const GET_MY_BILLING_PARTY_QUERY = gql`
    query getBillingParty($id: Int!) {
        billingParty(id: $id) {
            id
            overduePayments
            cost
            outstandingBalance
            code
            totalCreditCardFees

            payingMembers {
                id
                primary_paying_member
                first_name
                last_name
                email
            }
            booking {
                id
                start_date
                end_date

                group {
                    id
                    booking_form_url
                    name
                    description_checkin

                    tour {
                        id
                        display_name
                    }

                    hotel {
                        id
                        display_name
                    }
                }
            }
            members {
                id
            }
        }
    }
`;

const getMyBillingParty = (id: number) =>
    useQuery<MyBillingPartyData>(GET_MY_BILLING_PARTY_QUERY, {
        variables: {
            id
        }
    });

export default getMyBillingParty;
